export default state =>
  state.category.details?.featuredHeader?.isEnabled || false;
